/**
 * @file icon.tsx
 * @description 图标组件，封装平台内图标，方便统一管理和使用
 * @description 图片资源托管在 aiju 组件库（https://material.baidu-int.com/icon-library/e98dgr）中，请确保资源已上传至 aiju 库中
 */

import * as Icons from '@baidu-light-new/aiju';
import type {ComponentProps} from 'react';

export type IconName = keyof typeof Icons;

interface IconProps extends Omit<ComponentProps<'span'>, 'name'> {
    name: IconName;
    /** 宽高同值，默认 16 */
    size?: number;
}

const Icon: React.FC<IconProps> = ({name, size, style, ...rest}) => {
    const IconComponent = Icons[name];

    if (!IconComponent) {
        console.warn(`Icon "${name}" not found.`);
        return null;
    }

    return (
        <span
            {...rest}
            style={{
                display: 'inline-flex',
                lineHeight: 1,
                fontSize: size || 16,
                ...(style || {}),
            }}
        >
            <IconComponent />
        </span>
    );
};

export default Icon;
